import { useEffect, useState } from "react";
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper";
import { configureTableLazyState, defineTableColumnsFromArray, defineTableFilters } from "../../../../widgets/table/tableFeatures/tableFunctions";
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget";
import { useFetchDefectSegmentsQuery, useFetchRoadDiagnosticsSegmentsQuery } from "../../../../api/rtk/base/slices/diagnosticsApiSlice";
import { prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import TableTitleRow from "../../../../widgets/table/tableAddons/tableTitleRow/TableTitleRow";
import { useDispatch } from "react-redux";
import { setCurrentDefectSegment, setCurrentRoadDiagnosticsSegmentNew, showToastMessage } from "../../../../stateManagement/reducers";
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer";
import { DataTableSelectEvent } from "primereact/datatable";
import { navigateTo } from "../../../../widgets/navigationService/navigationServiceFunctions";
import { getDataArrayWithMaintenanceEnding, getDataArrayWithMaintenancePosition } from "../../../../features/dataFormatFunctions/formatMaintenancePoint";

const columnsStructure: any = [
    {
        headerName: "Начало, км",
        field: "Position",
        align: "right",
        valueType: "float"
    },
    {
        headerName: "Начало, км+",
        field: "MaintenancePosition",
        valueType: "int",
        align: "right"
    },
    {
        headerName: "Конец, км",
        field: "Ending",
        valueType: "float",
        filterPlaceholder: "Конец, км  =",
        align: "right"
    },
    {
        headerName: "Конец, км+",
        field: "MaintenanceEnding",
        valueType: "int",
        align: "right"
    },
    {
        headerName: "Тип",
        field: "DefectClassificator",
        valueType: "string",
        align: "right"
    }
]

export default function TableNestedDefectSegments() {
    const { eventId } = useParams()
    const dispatch = useDispatch()
    const [tableState, setTableState] = useState<any>(null)
    const [tableValue, setTableValue] = useState<any>([])
    const [columns, setColumns] = useState<any>([])

    const currentDiagnosticsSegment = useAppSelector(state => state.roadDiagnosticsSegments.currentRoadDiagnosticsSegment)

    const { data: requestedDiagnosticsSegment,
        isFetching: requestedDiagnosticsSegmentIsFetching,
        isError: requestedDiagnosticsSegmentIsError
    } = useFetchRoadDiagnosticsSegmentsQuery({ top: 1, filterString: `EventId eq ${eventId}` }, { skip: currentDiagnosticsSegment })

    const { data: defectSegment,
        isFetching: defectSegmentIsFetching,
        isError: defectSegmentIsError
    } = useFetchDefectSegmentsQuery({ top: 1, filterString: `EventId eq ${eventId}` })

    useEffect(() => {
        let columns = defineTableColumnsFromArray(columnsStructure)
        let filters = defineTableFilters(columns)
        setColumns(columns)
        setTableState(configureTableLazyState({ filters }))
    }, [])

    useEffect(() => {
        if (defectSegment?.value[0] && currentDiagnosticsSegment && columns) {
            const DefectClassificator = defectSegment?.value[0]?.DefectClassificator
            const { Position, Ending, MaintenancePosition, MaintenancePositionKm, MaintenancePositionM, MaintenanceEnding, MaintenanceEndingKm, MaintenanceEndingM } = currentDiagnosticsSegment
            let value: any = [
                {
                    Position,
                    Ending,
                    MaintenancePosition,
                    MaintenancePositionKm,
                    MaintenancePositionM,
                    MaintenanceEnding,
                    MaintenanceEndingKm,
                    MaintenanceEndingM,
                    DefectClassificator
                }
            ]
            value = prepareTableData(value, columns)
            value = getDataArrayWithMaintenanceEnding(value)
            value = getDataArrayWithMaintenancePosition(value)
            setTableValue(value)
        }
    }, [defectSegment, currentDiagnosticsSegment, columns])

    useEffect(() => {
        if (requestedDiagnosticsSegment?.value[0]) {
            dispatch(setCurrentRoadDiagnosticsSegmentNew(requestedDiagnosticsSegment?.value[0]))
        }
    }, [requestedDiagnosticsSegment])

    useEffect(() => {
        if (defectSegmentIsError || requestedDiagnosticsSegmentIsError) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error", windowType: "defectSegmentsTable" }))
        }
    }, [defectSegmentIsError, requestedDiagnosticsSegmentIsError])

    function onRowSelect(event: DataTableSelectEvent) {
        const defectSegment = event?.data
        const { DefectClassificator } = defectSegment ?? {}
        dispatch(setCurrentDefectSegment(defectSegment))
        navigateTo(`/app/diagnostics/diagnosticsSegments/${eventId}/defects/${DefectClassificator}`)
    }

    return (
        <div className="table-widget-with-toast half-size">
            <TableTitleRow text="Участки дефектов" />
            <ToastMessageContainer windowType="defectSegmentsTable" />
            <LoaderWrapper isLoading={defectSegmentIsFetching || requestedDiagnosticsSegmentIsFetching} className="table-with-title-row">
                <TableWidget
                    tableValue={tableValue}
                    tableState={tableState}
                    columns={columns}
                    canBeFiltered={false}
                    canBeSorted={false}
                    withTitleRow
                    onRowSelect={onRowSelect}
                />
            </LoaderWrapper>
        </div>
    )
}
